var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-pages"},[_c('div',{staticClass:"hero-pages__bg",style:({backgroundImage: 'url(' + _vm.props.image + ')'})},[_c('div',{staticClass:"hero-pages__overlay"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83295be6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero-pages/hero-pages.pug
// module id = p2zI
// module chunks = 0